module.exports = __webpack_public_path__ + "img/70_21.a7fcf6a5.png";